const KeyboardKeys = Object.freeze({
    valueCancel: 'Cancel',
    valueHelp: 'Help',
    valueBackSpace: 'Backspace',
    valueTab: 'Tab',
    valueClear: 'Clear',
    valueEnter: 'Enter',
    valueReturn: 'Enter',
    valueShift: 'Shift',
    valueControl: 'Control',
    valueAlt: 'Alt',
    valueOperatingSystem: 'OS',
    valuePause: 'Pause',
    valueCapsLock: 'CapsLock',
    valueEscape: 'Escape',
    valueSpace: ' ',
    valuePageUp: 'PageUp',
    valuePageDown: 'PageDown',
    valueEnd: 'End',
    valueHome: 'Home',
    valueLeft: 'ArrowLeft',
    valueUp: 'ArrowUp',
    valueRight: 'ArrowRight',
    valueDown: 'ArrowDown',
    valuePrintScreen: 'PrintScreen',
    valueInsert: 'Insert',
    valueDelete: 'Delete',
    value0: '0',
    value1: '1',
    value2: '2',
    value3: '3',
    value4: '4',
    value5: '5',
    value6: '6',
    value7: '7',
    value8: '8',
    value9: '9',
    valueA: 'a',
    valueB: 'b',
    valueC: 'c',
    valueD: 'd',
    valueE: 'e',
    valueF: 'f',
    valueG: 'g',
    valueH: 'h',
    valueI: 'i',
    valueJ: 'j',
    valueK: 'k',
    valueL: 'l',
    valueM: 'm',
    valueN: 'n',
    valueO: 'o',
    valueP: 'p',
    valueQ: 'q',
    valueR: 'r',
    valueS: 's',
    valueT: 't',
    valueU: 'u',
    valueV: 'v',
    valueW: 'w',
    valueX: 'x',
    valueY: 'y',
    valueZ: 'z',
    valueMeta: 'Meta',
    valueLeftCmd: 'Meta',
    valueRightCmd: 'Meta',
    valueContextMenu: 'ContextMenu',
    valueNumpad0: '0',
    valueNumpad1: '1',
    valueNumpad2: '2',
    valueNumpad3: '3',
    valueNumpad4: '4',
    valueNumpad5: '5',
    valueNumpad6: '6',
    valueNumpad7: '7',
    valueNumpad8: '8',
    valueNumpad9: '9',
    valueMultiply: '*',
    valueAdd: '+',
    valueSubtract: '-',
    valueDecimal: '.',
    valueDivide: '/',
    valueF1: 'F1',
    valueF2: 'F2',
    valueF3: 'F3',
    valueF4: 'F4',
    valueF5: 'F5',
    valueF6: 'F6',
    valueF7: 'F7',
    valueF8: 'F8',
    valueF9: 'F9',
    valueF10: 'F10',
    valueF11: 'F11',
    valueF12: 'F12',
    valueF13: 'F13',
    valueF14: 'F14',
    valueF15: 'F15',
    valueF16: 'F16',
    valueF17: 'F17',
    valueF18: 'F18',
    valueF19: 'F19',
    valueF20: 'F20',
    valueF21: 'F21',
    valueF22: 'F22',
    valueF23: 'F23',
    valueF24: 'F24',
    valueNumLock: 'NumLock',
    valueScrollLock: 'ScrollLock',
    valueSemicolon: ',',
    valueEquals: '=',
    valueComma: ',',
    valueDash: '-',
    valuePeriod: '.',
    valueSlash: '/',
    valueBackQuote: '`',
    valueOpenBracket: '[',
    valueBackSlash: '\\',
    valueCloseBracket: ']',
    valueQuote: "'"
});

export { KeyboardKeys };